import React, { useEffect, useState } from 'react';

/**
 * Ek hi reusable photo picker — Sale, Add Stock intake, Add Product seller.
 * Sirf UI; upload parent me uploadSalePhoto() se hota hai.
 */
export default function OptionalPhotoUpload({
  title = 'Photo',
  hint = '',
  file,
  onChange,
  /** Sirf tab set karo jab camera-only chahiye; default = gallery + camera dono */
  capture,
  className = 'mb-3'
}) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <div className={className}>
      {title ? (
        <label className="form-label">
          {title} <span className="text-muted fw-normal">(optional)</span>
        </label>
      ) : null}
      <div className="row g-2 align-items-center">
        <div className={preview ? 'col-md-7' : 'col-12'}>
          <input
            type="file"
            className="form-control form-control-sm"
            accept="image/jpeg,image/png,image/webp,image/*"
            {...(capture ? { capture } : {})}
            onChange={(e) => onChange(e.target.files[0] || null)}
          />
          {hint ? <small className="text-muted d-block mt-1">{hint}</small> : null}
          {!capture ? (
            <small className="text-muted d-block mt-1">Gallery se bhi choose kar sakte ho, sirf camera nahi.</small>
          ) : null}
        </div>
        {preview ? (
          <div className="col-md-5">
            <img
              src={preview}
              alt="Preview"
              style={{
                width: '100%',
                maxHeight: 120,
                objectFit: 'cover',
                borderRadius: 8,
                border: '1px solid #dee2e6'
              }}
            />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary mt-1 w-100"
              onClick={() => onChange(null)}
            >
              Remove photo
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
